import type { Appearance } from "@stripe/stripe-js"
import tokens from "../../design-tokens.json"
import { ColorScheme } from "./colorScheme"

/** `#RRGGBBAA` → `rgba(…)`, which Stripe's appearance rules accept. */
function rgba(hex: string) {
  const [r, g, b, a] = [1, 3, 5, 7].map((index) =>
    parseInt(hex.slice(index, index + 2), 16),
  )

  return `rgba(${r}, ${g}, ${b}, ${Math.round((a / 255) * 100) / 100})`
}

/**
 * Stripe's card form (Payment Element) in the app's colors, type and radii
 * (design-tokens.json), like the funnel's own fields (`.vm-input`).
 */
export function stripeAppearance(scheme: ColorScheme): Appearance {
  const colors = tokens.color[scheme]

  return {
    labels: "floating",
    theme: scheme === "dark" ? "night" : "stripe",
    variables: {
      borderRadius: `${tokens.radius.md}px`,
      colorBackground: colors.surface,
      colorDanger: colors.error,
      colorPrimary: colors.accent,
      colorText: colors.text,
      colorTextPlaceholder: colors.placeholder,
      colorTextSecondary: colors.secondaryText,
      fontFamily: `${tokens.font.family}, ${tokens.font.fallback}`,
    },
    rules: {
      ".Input": {
        border: `1px solid ${colors.fieldBorder}`,
        boxShadow: "none",
      },
      ".Input:focus": {
        border: `1px solid ${colors.accent}`,
        boxShadow: `0 0 0 3px ${rgba(colors.accentTint)}`,
      },
      ".Tab": {
        border: `1px solid ${colors.fieldBorder}`,
        boxShadow: "none",
      },
      ".Tab--selected": {
        border: `1px solid ${colors.accent}`,
      },
    },
  }
}
